<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="支付时间：">
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="开始日期" :default-time="['00:00:00', '23:59:59']" end-placeholder="结束日期" />
      </el-form-item>
      <el-form-item label="城市公司：">
        <el-select v-model="query.cityCompanyId" placeholder="请选择城市公司" clearable size="small" filterable>
          <el-option v-for="item in cityCompanyList" :key="item.key" :label="item.value" :value="item.key" />
        </el-select>
      </el-form-item>
      <el-form-item label="业务类型：">
        <el-select v-model="query.bizType" placeholder="请选择" clearable size="small">
          <el-option label="商城订单" :value="1" />
          <el-option label="充值" :value="2" />
          <el-option label="线下会议" :value="3" />
          <el-option label="课程" :value="5" />
          <el-option label="售后补款" :value="7" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import rechargeRecordApi from '@/api/recharge/rechargeRecord'
import { filterEmpty } from '@/utils'
import cityCompanyApi from '@/api/sys/cityCompany'
export default {
  data() {
    return {
      dateTime: [],
      query: {},
      cityCompanyList: []
    }
  },
  created() {
    this.loadCityCompany()
  },
  methods: {
    loadCityCompany() {
      cityCompanyApi.getOption().then(res => {
        if (res.code === '0') this.cityCompanyList = res.data || []
      })
    },
    handleDownload() {
      this.query.payTimeStart = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined
      this.query.payTimeEnd = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined
      return this.$common.confirm('是否确认导出')
        .then(() => rechargeRecordApi.allPaymentExport(filterEmpty(this.query)))
        .then(res => {
          if (res.code === '0') {
            setTimeout(() => { this.$emit('created') }, 1000)
          }
        })
    }
  }
}
</script>
